// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "babel-polyfill";

import hls from 'videojs-contrib-hls'
Vue.use(hls)
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.prototype.colorList = [0x90ee90, 0x2695fd, 0xec2287, 0xf743d9, 0xd0e60a]
import App from "./App";
import router from "./router";
import store from "./store";
// 防止重复点击
import preventReClick from './directive/preventRepeatClick'
Vue.use(preventReClick)

// 全局引入socket
import websocket from "@/assets/socket"
Vue.prototype.websocket = websocket
// 自定义标签使用
Vue.config.ignoredElements = ['wx-open-launch-weapp','wx-open-subscribe']

// vant
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import {
  Message
} from 'element-ui'

window.Promise = Promise;
import YDUI from "vue-ydui";
import "vue-ydui/dist/ydui.base.css";
import "vue-ydui/dist/ydui.px.css";
Vue.use(YDUI);
import Distpicker from "v-distpicker";
import axios from "axios";
Vue.prototype.axios = axios;
window.axios = axios;
Vue.prototype.https = axios;
Vue.prototype.$https = axios;
// Vue.prototype.mqtt = mqtt;

import Paho from 'paho-mqtt'; //引入
Vue.prototype.Paho = Paho;
import wx from 'weixin-js-sdk'; //引入
Vue.prototype.wx = wx;

// 引入公用函数
import {
  formattingUrl
} from "@/utils/index"
Vue.prototype.formattingUrl = formattingUrl;
// 引入share.js
import wxJsApi from "@/utils/share"
Vue.prototype.wxJsApi = wxJsApi;

Vue.config.productionTip = false;
Vue.prototype.$isTest = lycamWeb.isTest;
// import mqtt from 'mqtt'

import "./assets/js/common.js";
import "./assets/css/style.css";
import "./assets/css/advlist.css";
import "./assets/css/home.css";
// import "video.js/dist/video-js.css";
import "./lyfont/el-icon-liuyong.css";

import ly_api from "./assets/js/api.js";
Vue.prototype.$_api = ly_api;

import "@vant/touch-emulator";

import vueQr from "vue-qr";
Vue.use(vueQr);

import Meta from "vue-meta";
Vue.use(Meta);

import VueAwesomeSwiper from "vue-awesome-swiper";

import vueDanmaku from "vue-danmaku";
Vue.use(vueDanmaku);

// import style
import "swiper/swiper-bundle.css";
import {
  UserInfoApiFn
} from './request/index'
import {
  UserLoginApiFn
} from './request/index'

Vue.prototype.$UserInfoFn = UserInfoApiFn
Vue.prototype.$UserLoginFn = UserLoginApiFn



Vue.use(VueAwesomeSwiper /* { default options with global component } */ );

var lycamVue;

let _token_ = lycamWeb.parseQueryString(window.location.href)._token_;
if (_token_) {
  lycamWeb.setCookie("token", _token_);
  localStorage.setItem('token', _token_)
}
Vue.prototype.$isToday = function (date) {
  if (!date) {
    return false;
  }
  var istoday = lycamWeb.isToday(date);
  // console.log(istoday);
  return istoday;
};

Vue.prototype.$shotDate = function (date) {
  date = lycamWeb.shotDate(date);
  return date;
};

Vue.prototype.$afterNow = function (date) {
  if (!date) {
    return false;
  }
  return lycamWeb.afterNow(date);
};

Vue.prototype.$gotop = function (dom) {
  var timertt = setInterval(function () {
    var scrollTop = dom.scrollTop || document.body.scrollTop;
    var ispeed = Math.floor(-scrollTop / 3);
    // console.log(ispeed);
    if (scrollTop == 0) {
      clearInterval(timertt);
    }
    dom.scrollTop = document.body.scrollTop = scrollTop + ispeed;
  }, 30);
};
Vue.config.errorHandler = function (err, vm, info) {
  let {
    message,
    name,
    script,
    line,
    column,
    stack
  } = err;
};
Vue.prototype.$_reload = function () {
  window.location.reload();
};
Vue.prototype.$toXiaoDuo = function () {
  window.location.href =
    "https://www.aixiaoduo.com/c/index.html?src=414&key=tjzexkltrqukijqhgiyjdxrhruqeoghgptqozluzcoeuhkadwnenfksylxtctjyq&channel_id=845";
};

lycamWeb.delCookie("autoBao");

//操作 选择马甲
Vue.prototype.newSwitchMajia = function (streamId, reload) {
  // let that = this;
  return new Promise((resolve, reject) => {
    axios.post("/api/support/get/mask").then(res => {
      // console.log(res);
      if (res.data.code === 0) {
        // localStorage.setItem("apiTokenNew", res.data.data.token);

        if (streamId) {
          var a = {
            Displayname: res.data.data.Mask.Displayname,
            Avatarurl: res.data.data.Mask.Avatarurl,
            School: res.data.data.Mask.School,
            Id: res.data.data.Uids, //+ "_majia",
          };
          // console.log(a);
          localStorage.setItem(streamId, JSON.stringify(a));
          // localStorage.setItem("phone", item.Phone);
          // localStorage.setItem("Avatarurl", item.AvatarUrl);
          // localStorage.setItem("Displayname", item.DisplayName);
        }
        if (reload) {
          window.location.reload();
        }
        resolve(a);
      } else {
        // alert("切换失败,请联系管理员[" + res.data.msg + "]");
        reject("切换失败,请联系管理员");
      }
    });
  });
};
let isWeixin = lycamWeb.isWeixin()
let isLocalhost = window.location.href.indexOf("localhost") == -1
if (isLocalhost && !isWeixin) {
  Vue.prototype.$loading({
    lock: true,
    text: "请用微信浏览器打开",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
}
Vue.prototype.$_downloadFileByurl = function (url, filename) {
  console.log(url);
  console.log(filename);
  var a = document.createElement('a') // 创建一个a节点插入的document
  var event = new MouseEvent('click') // 模拟鼠标click点击事件
  a.download = filename || new Date().getTime() // 'beautifulGirl' 
  a.href = url // 将图片的src赋值给a节点的href
  a.setAttribute('download', filename + ".png")
  a.dispatchEvent(event) // 触发鼠标点击事件
}
Vue.prototype.$UserRegister = function (streamId) {
  return new Promise((resolve, reject) => {
    // console.log("store.state", store.state.userInfo);
    let userInfo = store.state.userInfo
    // let userInfo=lycamWeb.getCookie("userInfo");
    // console.log("userInfo", userInfo);
    // 判断 userInfo是否为空
    if (!userInfo.Ext) {
      Vue.prototype.$setAllCookies().then(res => {
        Vue.prototype.pduan(res.data, streamId)
        resolve()
      }).catch(error => {
        // console.log(2, error);
        // Vue.prototype.$UserRegister()
      });
    } else {
      resolve()
      Vue.prototype.pduan(userInfo, streamId)
    }
  })

}

Vue.prototype.pduan = function (userInfo, streamId) {
  // 如果含有SchoolId 和 电话号码 就修改填写电话号码的状态
  if (userInfo.Ext) {
    if (userInfo.User.Phone.indexOf(1) > -1 && userInfo.Ext.Schoolid) {
      // console.log('有电话有学校');
      Vue.prototype.$Register(2, streamId)
    } else if (userInfo.User.Phone.indexOf(1) > -1 && (userInfo.Ext.Schoolid == 0 || userInfo.Ext.Schoolid == "")) {
      // console.log('有电话没学校');
      if ((userInfo.Ext.Id == 0 || userInfo.Ext.Id == "")) {
        // console.log('没有三方信息');
        Vue.prototype.$Register(4, streamId)
      } else {
        Vue.prototype.$Register(3, streamId)
      }
    } else if (!userInfo.User.Phone.indexOf(1) > -1 && (userInfo.Ext.Schoolid == 0 || userInfo.Ext.Schoolid == "")) {
      // console.log('没有电话没有学校');
      Vue.prototype.$Register(4, streamId)
    } else {
      // console.log('都没走');
      Vue.prototype.$Register(4, streamId)
    }
  } else {
    Vue.prototype.$Register(4, streamId)
  }
}
// 定义一个全局的client
Vue.prototype.$streamChat = function () {

  if (!store.state.mainClient) {
    console.log(lycamWeb.IsPC());
    let url = "/api/stream/chat?From=" + (lycamWeb.IsPC() ? "GKBPC" : "")
    console.log(url);

    axios.get(url).then(res => {
      console.log("/api/stream/chat", res);

      if (res && res.data.code === 0 && !store.state.mainClient) {
        let data = res.data.data
        console.log("/api/stream/chat。执行");
        let mainClient = new Paho.Client(data.Endpoint.split("//")[1].split(":")[0], 443, data.Clientid); // AXQqAHMm
        Vue.prototype.$setMainClient(mainClient)
        console.log("store.state.mainClient", store.state.mainClient);
        store.state.mainClient.connect({
          useSSL: true,
          onSuccess: () => {
            console.log("onConnect:连接成功");
            Vue.prototype.$setConnectOK(true);
          },
          onFailure: message => {
            Vue.prototype.$setConnectOK(false);
            Vue.prototype.$setMainClient(null);
            try {} catch (e) {}
            console.log("onFailure:连接失败");
          },
          userName: data.Username,
          keepAliveInterval: 3,
          password: data.Userpass
        });

        store.state.mainClient.onConnectionLost = responseObject => {
          Vue.prototype.$setConnectOK(false);
          Vue.prototype.$setMainClient(null);
          if (responseObject.errorCode !== 0) {
            console.log("状态码不对");
            console.log(responseObject);
            return;
          }
        };
      }
    });
  }
}


// setInterval(() => {
//   if (!store.state.connectOK) {
//     Vue.prototype.$streamChat()
//   }
// }, 3000)

Vue.prototype.$setAllCookies = function (reload) {
  return new Promise((resolve, reject) => {
    UserInfoApiFn()
      .then(res => {
        lycamWeb.clearCookie();
        if (res && res.data && res.code == 0) {
          // 用户信息写入store
          console.log("$setUserInfo", res.data);
          Vue.prototype.$setUserInfo(res.data)
          // 写入cookie
          lycamWeb.setCookie("worker", res.data.isWorker);
          lycamWeb.setCookie("hasExtend", res.data.Ext.Id != 0 ? true : false);
          localStorage.setItem("Avatarurl", res.data.User.Avatarurl);
          localStorage.setItem("Displayname", res.data.User.Displayname);
          localStorage.setItem("userId", res.data.Uids);
          localStorage.setItem("phone", res.data.User.Phone);
          lycamWeb.setCookie("userId", res.data.Uids);
          lycamWeb.setCookie("phone", res.data.User.Phone);
          lycamWeb.setCookie("Avatarurl", res.data.User.Avatarurl);
          lycamWeb.setCookie("Displayname", res.data.User.Displayname);
          lycamWeb.setCookie("userInfo", res.data, 15);

          Vue.prototype.$UserRegister()
          if (res.data.Ext.School) {
            localStorage.setItem(
              "schoolName",
              res.data.Ext.School
            );
            lycamWeb.setCookie(
              "schoolName",
              res.data.Ext.School
            );
          }
          if (res.data.orgInfo && res.data.orgInfo.orgName) {
            localStorage.setItem(
              "orgInfo",
              JSON.stringify(res.data.orgInfo)
            );
            // lycamWeb.setCookie("orgInfo", res.data.data.orgInfo);
            // logo;
          } else {
            localStorage.removeItem("orgInfo");
            // lycamWeb.delCookie("orgInfo");
          }
          axios.defaults.headers.common["token"] = lycamWeb.getCookie("token");
          // setTimeout(() => {
          //   Vue.prototype.$streamChat()
          // }, 3000);
          if (reload) {
            Vue.prototype.$_reload();
          }
          resolve(res);
        } else {
          reject(res);
        }
      })
      .catch(err => {
        reject(err);
        // console.log(err);
      });

  });
};

Vue.prototype.$currentQuery = function () {
  try {
    let query = router.history.current.query;
    let newQuery = JSON.parse(JSON.stringify(query));
    return newQuery;
  } catch (e) {
    return {};
  }
};

Vue.prototype.$changeCurrentParams = function (newQuery = {}) {
  let path = router.history.current.path;
  //对象的拷贝
  router.push({
    path,
    query: newQuery
  });
};

Vue.prototype.$goHome = function () {
  wx.miniProgram.getEnv(function (res) {
    if (res.miniprogram) {
      wx.miniProgram.navigateBack();
    } else {
      router.push({
        name: "video"
        // query: { redurl: "" }
      });
    }
    // console.log(res.miniprogram); // true
  });
};

Vue.prototype.$goBack = function () {
  if (window.history.length <= 1) {
    // router.push({ path: "/" });
    Vue.prototype.$goHome();
    return false;
  } else {
    router.go(-1);
  }
};

// Vue.prototype.$initZhuanData = function(
//   page = 1,
//   size = 10,
//   params = {},
//   dist = ''
//   // showske = false
// ) {
//   console.log(dist);
//   return new Promise((resolve, reject) => {
//     // var url = search ? ly_api.zhuan.searchUrl : ly_api.zhuan.listUrl;
//     var url = "/api/stream/groups/find";
//     if (!params) {
//       params = {};
//     }
//     params.Page = page;
//     params.Limit = size;
//     // 拿到省份得Id进行查询
//     // params.Id = Id;
//     // if (page == 1 && showske) {
//     //   params.showske = true;
//     // }
//     // params.type = "gkb";
//     // params.source = "h5";
//     // params.status = status;
//     // + "?page=" + page + "&limit=" + size
//     axios.get(url, { params }).then(res => {
//       resolve(res);
//       // console.log(store.state.advjson);
//     });
//   });
// };
// alert(window.location.href)
if (window.location.href.indexOf("shareLink") > -1) {
  let decodeArray = window.location.href.split("?shareLink=")
  window.location.href = decodeArray[0] + "?zjl=2#/" + decodeURIComponent(decodeArray[1])
}

Vue.prototype.$shareData = function (shareData) {
  if (!shareData) {
    shareData = {
      // 分享到朋友
      title: "考宝学涯", // 分享标题
      desc: "关注“考宝学涯”公众号，看招办主任宣讲，选对学校，选对专业！", // 分享描述
      link: window.location.href, // 分享链接，默认分享当前页，目前微信分享不支持https格式的链接
      imgUrl: "http://shouboke.tv/images/kaobaoxueya.png", // 分享图标
      success: function () {},
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    };
  }
  // 转义link
  if (shareData.link.indexOf("/#/") > -1) {
    let linkArray = shareData.link.split("/#/");
    shareData.link = linkArray[0] + "?shareLink=" + encodeURIComponent(linkArray[1])
  }
  return new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.hasConfig = true;
      // alert("22",window.location.href)
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);
      wx.hideMenuItems({
        menuList: [
          "menuItem:copyUrl",
          "menuItem:exposeArticle",
          "menuItem:share:weiboApp",
          "menuItem:favorite",
          "menuItem:share:facebook",
          "menuItem:share:QZone",
          "menuItem:editTag",
          "menuItem:delete",
          "menuItem:originPage",
          "menuItem:openWithQQBrowser",
          "menuItem:openWithSafari",
          "menuItem:share:email",
          "menuItem:share:brand"
        ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });

      resolve(true);
    });

    wx.error(function (info) {
      console.log(info);

      wx.hasConfig = false;
      reject(info);
    });
  });
};
// 初始化
Vue.prototype.$configWx = function (shareData) {
  return new Promise((resolve, reject) => {
    wxJsApi.wxShare(shareData);
  });
};
// {'Content-Type':'application/json','Access-Control-Allow-Origin':'*'}
axios.defaults.baseURL = lycamWeb.getHost();
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.post["Content-Type"] = "application/json";

Vue.prototype.$loginphone = function () {
  Vue.prototype.$showAppView();
  if (window.location.href.indexOf("login") > -1) {} else if (window.location.href.indexOf("#") > -1) {
    // console.log(route);
    if (!lycamWeb.notNeedlogin()) {
      lycamWeb.setCookie("_redirecturl", window.location.href, 1);
      Vue.prototype.$showLogin(true);
      // if(!lycamVue)
    }
  }
};

// 显示视图
Vue.prototype.$showAppView = function () {
  if (!lycamVue) {
    lycamVue = new Vue({
      el: "#app",
      router,
      store,
      components: {
        App
      },
      template: "<App/>"
    });
  }
};
axios.defaults.timeout = 10000;
let reqNum = 0;
let loading
// axios请求拦截器
axios.interceptors.request.use(
  config => {
    // if (loading) {
    //   loading = Vue.prototype.$loading({
    //     lock: true,
    //     text: "数据加载中",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)"
    //     // background: "#fff"
    //   });
    // }

    // 本地启用使用固定token
    if (window.location.href.indexOf("localhost") > -1) {
      config.headers['token'] = store.state.myToken
    }
    if (config.method === "post") {

      config.data = {
        // Device: lycamWeb.IsPC() ? 0 : 1,
        // _from_: "weixin_web",
        ...config.data
      };
      if (config.url.indexOf("user/wxlogin") > -1) {
        let obj = {};
        let url = formattingUrl(window.location.href);
        if (url.indexOf('videoDetail?') != -1) {
          let arr = url.slice(url.indexOf('videoDetail?') + 12).split('&');
          console.log("kDWkAsUl1ayH", arr, url.slice(url.indexOf('videoDetail?') + 12));
          arr.forEach(item => {
            let param = item.split('=');
            obj[param[0]] = param[1];
          })
          console.log(obj);
        }
        if (obj && obj.id) {
          config.data.From = obj.id
        }
      }
    } else if (config.method === "get") {
      config.params = {
        // Device: lycamWeb.IsPC() ? 0 : 1,
        // _from_: "weixin_web",
        ...config.params
      };
    }
    reqNum++;
    // if (
    //   config.url.indexOf("hideLoading=true") > -1 ||
    //   (config.data && config.data.hideLoading)
    // ) {
    // } else {
    //   store.commit("skeState", true);
    //   // Vue.prototype.showSke(true);
    //   // showFullScreenLoading();
    // }

    if (
      config.url.indexOf("showske=true") > -1 ||
      (config.data && config.data.showske) ||
      (config.params && config.params.showske)
    ) {
      store.commit("skeState", true);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
// axios响应拦截器
axios.interceptors.response.use(
  function (response) {
    let code = response.data.code;
    // 排查一些接口
    let isV = true;
    if (response.request.responseURL.indexOf("_pdfdata") > -1) {
      isV = false
    }
    // 拦截wxlogin接口
    if (response.request.responseURL.indexOf("user/wxlogin") > -1 && isLocalhost) {
      lycamWeb.setCookie("_subwx", true, 1);
      console.log("response.data.data.ChatType", response.data.data.ChatType);

      // 提示锁定
      if (code == 800) {
        Message({
          message: "用户" + response.data.msg,
          type: 'error',
          duration: 5 * 1000
        })
        return
      }
      // 接口异常跳转首页
      if (code != 0) {
        window.location.href = lycamWeb.webHost()
      }
    }
    // 拦截userinfo接口
    if (response.request.responseURL.indexOf("user/info") > -1 && isLocalhost) {
      Vue.prototype.$setChatType(response.data.data.ChatType)
      lycamWeb.setCookie("ChatType", response.data.data.ChatType, 1);
    }
    if (code != 0 && isV) {
      // 全部提示
      // 本地启用提示打印
      if (window.location.href.indexOf("localhost") > -1) {
        Message({
          message: response.data.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }

      // console.log(response);
      var config = response.config;
      if (
        config.url.indexOf("showske=true") > -1 ||
        (config.data && config.data.showske) ||
        (config.params && config.params.showske)
      ) {
        setTimeout(() => {
          store.commit("skeState", false);
        }, 50);
      }
      // axios.defaults.baseURL = lycamWeb.getHost();
      // tryHideFullScreenLoading();
      reqNum--;
      // console.log(reqNum);
      // 对响应数据做点什么

      // 特殊code 201表示服务请求有延时,code 200表示服务器请求正常
      if (code == 201 && !store.httpDelayed) {
        Vue.prototype.$changeHttpDelayed(false)
      }
      if (code == 200 && store.httpDelayed) {
        Vue.prototype.$changeHttpDelayed(false)
      }

      // 对返回code 401无权限 的处理
      if (code == 401) {
        // lycamWeb.delCookie("token");
        if (lycamWeb.is_weixn_qq() == "weixin") {
          console.log(13212132);
          // 用户授权
          lycamWeb.delCookie("token");
          var reg = new RegExp("\\?from\\=groupmessage");
          var cc = window.location.href.replace(reg, "");
          var reUrl = encodeURIComponent(cc);
          console.log(reUrl);
          // var reUrl = encodeURIComponent(window.location.href);
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            lycamWeb.getAppid() +
            "&redirect_uri=" +
            reUrl +
            "&response_type=code&scope=snsapi_userinfo&state=315318";
        } else if (lycamWeb.is_weixn_qq() == "QQ" && !lycamWeb.IsPC()) {
          lycamWeb.delCookie("token");
          // var reUrl = encodeURIComponent(window.location.href);
          var reg = new RegExp("\\?from\\=groupmessage");
          var cc = window.location.href.replace(reg, "");
          var reUrl = encodeURIComponent(cc);
          window.location.href =
            "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=1105569906&redirect_uri=" +
            reUrl +
            "&state=315318&scope=get_user_info";
        } else {
          if (reqNum == 0) {
            // lycamWeb.delCookie("token");
            // Vue.prototype.$loginphone();
            lycamWeb.delCookie("token");
            Vue.prototype.$loginphone();
          }
        }
        return;
      }
      if (reqNum == 0) {
        setTimeout(() => {
          store.commit("skeState", false);
        }, 50);
      }
      return response;
    } else {
      setTimeout(() => {
        store.commit("skeState", false);
      }, 100);
      return response;
    }

  },
  function (error) {
    // axios.defaults.baseURL = lycamWeb.getHost();
    // tryHideFullScreenLoading();
    reqNum--;
    setTimeout(() => {
      store.commit("skeState", false);
    }, 100);
    // console.log(reqNum);
    if (error.response) {
      // 测试登录
      let params = {
        phone: '18981717357',
        plainpwd: 'pass1234',
      };


      let status = error.response.status;
      if (status == 403) {
        if (lycamWeb.is_weixn_qq() == "weixin") {
          console.log(13212132);
          // 用户授权
          lycamWeb.delCookie("token");
          console.log("token", lycamWeb.getCookie("token"));
          Vue.prototype.$setErrorNum(store.state.errorNum + 1);
          // alert(store.state.errorNum)
          if (store.state.errorNum == 1) {
            var reg = new RegExp("\\?from\\=groupmessage");
            var cc = window.location.href.replace(reg, "");
            var reUrl = encodeURIComponent(cc);
            var reUrl = encodeURIComponent(window.location.href);
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              lycamWeb.getAppid() +
              "&redirect_uri=" +
              reUrl +
              "&response_type=code&scope=snsapi_userinfo&state=3153181";
          }
        } else if (lycamWeb.is_weixn_qq() == "QQ" && !lycamWeb.IsPC()) {
          lycamWeb.delCookie("token");
          var reg = new RegExp("\\?from\\=groupmessage");
          var cc = window.location.href.replace(reg, "");
          var reUrl = encodeURIComponent(cc);
          // var reUrl = encodeURIComponent(window.location.href);
          window.location.href =
            "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=1105569906&redirect_uri=" +
            reUrl +
            "&state=315318&scope=get_user_info";
        } else {
          if (reqNum == 0) {
            lycamWeb.delCookie("token");
            Vue.prototype.$loginphone();
          }
        }
        return;
      } else {
        console.log("服务器连接失败！" + error.message);
      }
    }
    // 对响应错误401无权限 的处理

    // 超时处理
    var config = error.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(error);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(error);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function () {
      return axios(config);
    });

    // return Promise.reject(error);
  }
);
if (lycamWeb.getCookie("token")) {
  lycamWeb.delCookie("QQid");
  axios.defaults.headers.common["token"] = lycamWeb.getCookie("token");
  Vue.prototype.$streamChat()
  Vue.prototype.$setAllCookies().then(res => {
    Vue.prototype.$showAppView();
  });
} else if (window.location.href.indexOf("access_token") > -1) {
  var c = lycamWeb.parseQueryString(window.location.href)["#/access_token"];
  UserLoginApiFn()
    .then(res => {
      if (res.code == 0) {
        lycamWeb.setCookie("token", res.data.Token, 15);
        lycamWeb.setCookie("userInfo", res.data, 15);
        localStorage.setItem('token', res.data.Token)
        axios.defaults.headers.common["token"] = lycamWeb.getCookie(
          "token"
        );

        Vue.prototype.$setUserInfo(res.data)

        Vue.prototype.$UserRegister()
        Vue.prototype.$streamChat()
        Vue.prototype.$setAllCookies();
        Vue.prototype.$showAppView();
      } else {
        Vue.prototype.$loginphone();
        alert("请求失败");
      }
    })
    .catch(err => {
      Vue.prototype.$showAppView();
    });
} else if (lycamWeb.parseQueryString(window.location.href).code) {
  // alert('有code');
  if (lycamWeb.is_weixn_qq() == "weixin") {
    //wxWeb   微信登录
    UserLoginApiFn()
      .then(res => {
        if (res.code == 0) {
          lycamWeb.setCookie("token", res.data.Token, 15);
          lycamWeb.setCookie("userInfo", res.data, 15);
          localStorage.setItem('token', res.data.Token)
          axios.defaults.headers.common["token"] = lycamWeb.getCookie(
            "token"
          );

          Vue.prototype.$setUserInfo(res.data)
          Vue.prototype.$UserRegister()

          Vue.prototype.$streamChat()

          Vue.prototype.$setAllCookies();
          Vue.prototype.$showAppView();
        }
      });
  } else {
    Vue.prototype.$showAppView();
  }
} else {
  if (lycamWeb.is_weixn_qq() == "weixin") {
    lycamWeb.delCookie("token");
    var reg = new RegExp("\\?from\\=groupmessage");
    var cc = window.location.href.replace(reg, "");
    var reUrl = encodeURIComponent(cc);
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      lycamWeb.getAppid() +
      "&redirect_uri=" +
      reUrl +
      "&response_type=code&scope=snsapi_userinfo&state=3153182";
  } else if (lycamWeb.is_weixn_qq() == "QQ" && !lycamWeb.IsPC()) {
    lycamWeb.delCookie("token");
    lycamWeb.setCookie("QQlogin", true);
    var reUrl = encodeURIComponent(lycamWeb.webHost());
    if (window.location.href.indexOf("videoDetail?id") > -1) {
      var id = lycamWeb.parseQueryString(window.location.href).id;
      if (id) {
        id = id;
      } else {
        var curl = window.location.href;
        var reg = new RegExp("\\?from\\=groupMessage");
        var cc = curl.replace(reg, "");
        id = lycamWeb.parseQueryString(cc).id;
        if (id) {
          id = id;
        } else {
          var reg = new RegExp("\\?from\\=singleMessage");
          var cc = curl.replace(reg, "");
          id = lycamWeb.parseQueryString(cc).id;
        }
      }
      reUrl += "#videoDetail?id=" + id;
      lycamWeb.setCookie("QQid", id);
    }
    window.location.href =
      "https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101525018&redirect_uri=" +
      reUrl +
      "&state=315318&scope=get_user_info";
  } else {
    if (!lycamWeb.notNeedlogin()) {
      lycamWeb.delCookie("token");
      Vue.prototype.$loginphone();
    } else {
      Vue.prototype.$showAppView();
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.js